import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { SystemOverview } from './components/SystemOverview';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemBlueprint } from './components/SystemBlueprint';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { Steps } from './components/Steps';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div lang="tr" className="min-h-full w-full overflow-x-hidden bg-warm font-sans text-navy" data-id="element-0" data-mp="28te1n9vnj3li">
      <MetaPixel data-id="element-1" data-mp="23u9tmmkgrbwr" />
      <OfferBar data-id="element-2" data-mp="23utcq6luo6cd" />
      <div className="h-11" aria-hidden="true" data-id="element-3" data-mp="23t8heerpojdg" />
      <main data-id="element-4" data-mp="3ikr002qv3a7b">
        <Hero data-id="element-5" data-mp="3iiwfgpji5k3r" />
        <SystemOverview data-id="element-6" data-mp="3ijfvu1ti80fo" />
        <Testimonials data-id="element-7" data-mp="3ihuyy5jpw5en" />
        <PainPoints data-id="element-8" data-mp="3mlaxx8j9ehui" />
        <SystemBlueprint data-id="element-9" data-mp="3mkrcviybbdc9" />
        <Bonuses data-id="element-10" data-mp="3mjzu58ptda3e" />
        <Pricing data-id="element-11" data-mp="3mjg7xft4rzjk" />
        <MoreTestimonials data-id="element-12" data-mp="3rc9dg5wfbbwp" />
        <Guarantee data-id="element-13" data-mp="3rbzomln47asl" />
        <Steps data-id="element-14" data-mp="3rdkh85pvcjnt" />
        <FinalCTA data-id="element-15" data-mp="3rd19tixuhdo1" />
        <FAQ data-id="element-16" data-mp="3relv0hy9rk98" />
      </main>
      <Footer data-id="element-17" data-mp="6hr7hlrojf6" />
    </div>;
}